"use client";
import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const WhatweBanner = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
         

        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const adjustHeights = () => {
      const items = document.querySelectorAll(".topsectslider_item");
      if (items.length === 0) return;

      let maxHeight = 0;

      // Reset heights for recalculation
      items.forEach((item) => {
        item.style.height = "auto";
      });

      // Find the tallest element
      items.forEach((item) => {
        const itemHeight = item.offsetHeight;
        if (itemHeight > maxHeight) maxHeight = itemHeight;
      });

      // Apply tallest height to all items
      items.forEach((item) => {
        item.style.height = `${maxHeight}px`;
      });
    };

    // Delay adjustment to ensure rendering
    setTimeout(() => {
      adjustHeights();
    }, 100);

    // Handle resize
    window.addEventListener("resize", adjustHeights);

    return () => {
      window.removeEventListener("resize", adjustHeights);
    };
  }, []);

  return (
    <div className="slider-container about_topsectslider1">
      <Slider {...settings}>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">1</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Claims optimization & cost management</h3>
              <p className="indus_desc1">We streamline the claims process from end to end, identifying opportunities to reduce costs while enhancing speed and accuracy. Our data-driven insights help you eliminate inefficiencies and minimize unnecessary expenditures.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">2</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Fraud detection & risk assessment</h3>
              <p className="indus_desc1">Detecting fraudulent claims early can save millions. By leveraging predictive analytics, anomaly detection, and machine learning models, we identify potential fraud in real-time, helping you take proactive action and safeguard resources.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">3</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Revenue cycle management</h3>
              <p className="indus_desc1">Optimize revenue flows with data insights into billing, collections, and reimbursement processes. Our analytics uncover bottlenecks and streamline workflows, ensuring smoother cash flow and timely reimbursements.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">4</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Compliance monitoring & regulatory reporting</h3>
              <p className="indus_desc1">Stay ahead of regulatory changes and ensure compliance with industry standards. Our solutions help you track key metrics, generate audit-ready reports, and reduce risks associated with non-compliance.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">5</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Patient & provider insights</h3>
              <p className="indus_desc1">Gain a clearer understanding of patient demographics, treatment outcomes, and provider performance. By analyzing claims data, we help you make informed decisions that enhance patient care and provider efficiency.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">6</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Claims denial management</h3>
              <p className="indus_desc1">Denied claims are a major pain point for healthcare providers. Our analytics solutions provide insights into denial trends, enabling you to address root causes, improve appeal success rates, and reduce claim rejection.</p>
            </div>
          </div>
        </div>

      </Slider >
    </div >
  );
};

export default WhatweBanner;
